import { Controller } from "@hotwired/stimulus"

// Anonymous feedback for the AI summary (see ai_summary/_feedback.html.slim).
// The forms are submitted by Turbo; the server replies with Turbo Streams.
export default class extends Controller {
  static targets = ["rating", "comment", "counter"]

  // Choosing a rating saves it right away. The rating is disabled until the
  // response arrives, so quick clicks don't create more than one feedback.
  // Turbo has read the form data at this point already.
  rate() {
    this.ratingTarget.form.requestSubmit()
    this.ratingTarget.disabled = true
  }

  // Re-enables the rating if the request failed (a response replaces the form).
  enable() {
    this.ratingTarget.disabled = false
  }

  count() {
    this.counterTarget.textContent = `${this.commentTarget.value.length} / ${this.commentTarget.maxLength}`
  }
}
